import _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { customFetch, CustomFetchState } from '../utils/helpers'

export interface UseOrganizationsOptions {
  limit?: number,
  offset?: number,
  adminListing?: boolean,
}

const defaultOptions = {
  limit: 10,
  offset: 0,
  adminListing: false,
}

export const useOrganizationsById = (orgIds: number[] = [], options: UseOrganizationsOptions = {}) => {
  const [ids, setIds] = useState(orgIds)
  const [state, setState] = useState({ loading: false, error: null, data: null })
  const onUpdate = useCallback((newState: CustomFetchState) => setState({ ...state, ...newState }), [])

  const filteredOrgIds = _.uniq(
    orgIds.filter((orgid: number) => orgid !== undefined)
  ).sort((a, b) => a - b)

  // https://github.com/facebook/react/issues/14476#issuecomment-471199055
  if (!_.isEqual(filteredOrgIds, ids)) {
    setIds(filteredOrgIds)
  }

  useEffect(
    () => {
      if (ids.length === 0) {
        setState({ loading: false, error: null, data: null })
      } else {
        const searchQuery = [{ field: 'id', operand: 'IN', value: ids }]
        const fetchOptions: RequestInit = {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...defaultOptions,
            ...options,
            criteria: [searchQuery],
          }),
        }
        const { cancel } = customFetch('/accountservice/api/v3/organizations/search', fetchOptions, onUpdate)
        return () => cancel()
      }
    },
    [ids, options.limit, options.offset, options.adminListing]
  )

  return state
}

export default useOrganizationsById
